module.exports = __webpack_public_path__ + "assets/close.7f45f9fa832d0005b8cab0dcd9808b9a.png";